import { SoProcessTypesEnum } from "@gtpl/shared-models/common-models";

export class SoTypeReq{
    soType:SoProcessTypesEnum;
    unitId:number;
}